export type CsChatConnectionOptions = {
  host: string;
  protocol: "ws" | "wss";
};

export const disabledCsChatConnectionOptions: CsChatConnectionOptions = {
  host: "localhost:8788",
  protocol: "ws",
};

export const isCsChatEnabled = (
  workerBaseUrl: string | undefined,
  nodeEnv = process.env.NODE_ENV,
): boolean => Boolean(workerBaseUrl) || nodeEnv !== "production";

export const resolveCsChatWorkerUrl = (value: string | undefined): string =>
  normalizeCsChatWorkerUrl(value ?? getDevelopmentCsChatWorkerUrl());

export const toCsChatConnectionOptions = (
  value: string,
): CsChatConnectionOptions => {
  const url = new URL(value);

  return {
    host: url.host,
    protocol: toWebSocketProtocol(url.protocol),
  };
};

const getDevelopmentCsChatWorkerUrl = (): string => {
  if (process.env.NODE_ENV !== "production") {
    return "http://localhost:8788";
  }

  throw new Error(
    "Missing required environment variable: NEXT_PUBLIC_SUNSUN_CHAT_BASE_URL",
  );
};

const normalizeCsChatWorkerUrl = (value: string): string => {
  const url = new URL(value);

  if (url.protocol === "ws:") {
    url.protocol = "http:";
  } else if (url.protocol === "wss:") {
    url.protocol = "https:";
  } else if (url.protocol !== "http:" && url.protocol !== "https:") {
    throw new Error(`Unsupported CS chat worker URL protocol: ${url.protocol}`);
  }

  return url.toString().replace(/\/+$/, "");
};

const toWebSocketProtocol = (protocol: string): "ws" | "wss" => {
  if (protocol === "https:" || protocol === "wss:") {
    return "wss";
  }

  if (protocol === "http:" || protocol === "ws:") {
    return "ws";
  }

  throw new Error(`Unsupported CS chat worker URL protocol: ${protocol}`);
};
